import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CaseHistoryComponent } from './case-dashboard/casehistory/casehistory.component';
import { DefaultGuard } from './shared/guards/default-guard.service';
import { LoginComponent } from '../app/authenticate/login/login.component';
import { AuthGuard } from '@shared/guards/auth.service';
import { MaintenanceComponent } from './maintenance/maintenance.component';

const routes: Routes = [
  {
    path: ':id/patientviewer',
    loadChildren: () =>
      import('./MRIEditer/MRIEditer.module').then((mod) => mod.MRIEditerModule),
  },
  { path: 'signin', component: LoginComponent, canActivate: [] },
  {
    path:"maintenance",
    component: MaintenanceComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}